module.exports = __webpack_public_path__ + "img/home-selected.ba62a010.svg";